// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_AppointmentsList_wrapper__12qyg","list":"_AppointmentsList_list__3RwAg"};